import { useEffect } from "react";

import { LoadScript, type LoadScriptOptions } from "../lib/LoadScript";

const useScript = (options: LoadScriptOptions) =>
  useEffect(() => {
    LoadScript(options).catch((error) => {
      options.onError?.(error);
    });
    //eslint-disable-next-line
  }, []);

export { useScript };
